import { Loader2 } from 'lucide-react';
import { lazy, Suspense, useEffect, useState } from 'react';

const LazyAiChatWidgetContent = lazy(() => import('./AiChatWidgetContent'));
const assetBase = '';

export default function AiChatWidget() {
    const [shouldRenderWidget, setShouldRenderWidget] = useState(false);
    const [shouldOpenOnMount, setShouldOpenOnMount] = useState(false);
    const [showBubble, setShowBubble] = useState(false);
    const [bubbleText, setBubbleText] = useState('Hi! Need help?');

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        const messages = [
            'Hi! Need help?',
            'Ask me anything about NC!',
            'Looking for programs or events?',
            "I'm here to assist you",
            'Click me if you need help!',
        ];

        let hideTimeoutId: number | null = null;
        let nextBubbleTimeoutId: number | null = null;

        const showBubbleOnce = () => {
            const nextMessage = messages[Math.floor(Math.random() * messages.length)];
            setBubbleText(nextMessage);
            setShowBubble(true);

            hideTimeoutId = window.setTimeout(() => {
                setShowBubble(false);
            }, 4000);
        };

        const scheduleNextBubble = () => {
            const delay = Math.floor(Math.random() * 10000) + 15000;

            nextBubbleTimeoutId = window.setTimeout(() => {
                showBubbleOnce();
                scheduleNextBubble();
            }, delay);
        };

        const initialTimeoutId = window.setTimeout(() => {
            showBubbleOnce();
            scheduleNextBubble();
        }, 3000);

        return () => {
            window.clearTimeout(initialTimeoutId);

            if (hideTimeoutId !== null) {
                window.clearTimeout(hideTimeoutId);
            }

            if (nextBubbleTimeoutId !== null) {
                window.clearTimeout(nextBubbleTimeoutId);
            }
        };
    }, []);

    if (shouldRenderWidget) {
        return (
            <Suspense fallback={null}>
                <LazyAiChatWidgetContent initialOpen={shouldOpenOnMount} />
            </Suspense>
        );
    }

    return (
        <div className="fixed bottom-7 left-1/2 z-[3500] flex -translate-x-1/2 flex-col items-center md:right-7 md:left-auto md:translate-x-0">
            <div
                className={`mb-2.5 w-max max-w-[220px] rounded-[14px] bg-white px-3 py-2 text-center text-[13px] text-gray-800 shadow-lg transition-all duration-300 ${
                    showBubble ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-2.5 opacity-0'
                }`}
            >
                {bubbleText}
            </div>
            <button
                type="button"
                onClick={() => {
                    setShowBubble(false);
                    setShouldOpenOnMount(true);
                    setShouldRenderWidget(true);
                }}
                className="flex h-[95px] w-[95px] items-center justify-center overflow-hidden rounded-full bg-white shadow-lg transition-shadow hover:shadow-xl"
                aria-label="Open NC Support Assistant"
            >
                {shouldOpenOnMount ? (
                    <Loader2 className="h-6 w-6 animate-spin text-[#0A7A35]" />
                ) : (
                    <img
                        src={`${assetBase}/images/ai.webp`}
                        alt="Northeastern College AI Avatar"
                        className="h-[120px] w-[120px] object-contain"
                        loading="lazy"
                        decoding="async"
                    />
                )}
            </button>
        </div>
    );
}
